<template>
  <div>
    <!-- Overlay -->
    <transition name="fade">
      <div v-if="props.isPanelOpen" class="overlay" @click="isSubPanelOpen ? closeSubPanel() : closePanel()"></div>
    </transition>

    <!-- Sliding Panel -->
    <transition name="slide">
      <aside v-if="props.isPanelOpen" class="panel">
        <Button class="go-back-button sm outline black icon icon-left" icon="bi-arrow-left" @click="isSubPanelOpen ? closeSubPanel() : closePanel()" :label="$t('other.actions.back')"></Button>
        <div class="panel-content">
          <slot name="content"></slot>
        </div>
      </aside>
    </transition>
  </div>
</template>

<script setup lang="ts">
import Button from '@/components/global/Button.vue';

const props = defineProps<{
  isPanelOpen: boolean,
  isSubPanelOpen?: boolean,
}>();

const emit = defineEmits<{
  (e: 'closePanel'): void,
  (e: 'closeSubPanel'): void,
}>();

function closePanel() {
  emit('closePanel');
}

function closeSubPanel() {
  emit('closeSubPanel');
}

</script>

<style scoped lang="scss">
.go-back-button {
  position: absolute;
  right: 1.5rem;
  top: 1rem;
}
/* Overlay */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10;
}

/* Panel */
.panel {
  position: fixed;
  top: 0;
  right: 0;
  min-width: 600px;
  max-width: 100vw;
  height: 100vh;
  background: var(--white-color);
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
  z-index: 20;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}

.panel-content {
  //padding: 40px;
  height: 100%;

  &.dark {
    color: white;
    background-color: rgba(0, 0, 0, 0.95);
  }
}

/* Transitions */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
